import client from './modules/client'
import monitoring from './modules/monitoring'
import period from './modules/common/Period'
import regions from './modules/common/Regions'

export default {
  namespaced: true,
  modules: {
    client,
    monitoring,
    period,
    regions
  }
}
